import { Component } from 'preact';
import Slider from './Slider';
import PanControl from './PanControl';
import MapLegend from './MapLegend';
import { currentScale, onScaleChange, onResize, zoom, zoomIn, zoomOut, panLeft, panRight, panUp, panDown, onMapReady } from '../lib/worldmap';
import { currentPath } from '../lib/utils';
import { RESOURCES, UNREST } from '../lib/options-config';
// import sliderGradationDataUri from '../images/slider-gradation.svg';

const ZOOM_STEP = 0.2;

export default class MapControls extends Component {
  // transformInputScale (scale) {
  //   const { zoomMin, zoomMax } = this.state;
  //   const range = zoomMax - zoomMin;
  //   const valueRatio = (scale - zoomMin) / range;
  //   // const adjustedRatio = 1 - ((1 - valueRatio) * (1 - valueRatio));
  //   const adjustedRatio = valueRatio * valueRatio;
  //   const adjustedScale = adjustedRatio * range + zoomMin;

  //   return adjustedScale;
  // }

  // untransformInputScale (adjustedScale) {
  //   const { zoomMin, zoomMax } = this.state;
  //   const range = zoomMax - zoomMin;
  //   const adjustedRatio = (adjustedScale - zoomMin) / range;
  //   // const valueRatio = 1 - Math.sqrt(1 - adjustedRatio);
  //   const valueRatio = Math.sqrt(adjustedRatio);
  //   const scale = valueRatio * range + zoomMin;
    
  //   return scale;
  // }

  zoom = scale => zoom(scale)

  _setYearThrottled = () => {
    this.throttlingYearChange = false;
    this.props.onChangeYear(this.throttledYear);
  }

  setYear = year => {
    if (this.throttledYear === year) {
      return;
    }

    this.throttledYear = year;

    if (!this.throttlingYearChange) {
      this.throttlingYearChange = true;
      requestAnimationFrame(this._setYearThrottled);
    }
  }

  // setYear = year => {
  //   this.props.onChangeYear(year);
  // }

  componentWillMount () {
    onScaleChange(scale => this.setState({ scale }));
    onResize(({ zoomMin, zoomMax }) => this.setState({ zoomMin, zoomMax }));

    onMapReady()
    .then(({ zoomMin, zoomMax, currentScale }) =>
      this.setState({ zoomMin, zoomMax, scale: currentScale })
    );
  }

  zoomIn = () => {
    const { zoomMax } = this.state;
    const scale = currentScale(true);

    if (scale === zoomMax) {
      return;
    }

    if ((zoomMax - scale - ZOOM_STEP) < 0.1) {
      zoom(zoomMax);
    }

    else {
      zoomIn(ZOOM_STEP);
    }
  }

  zoomOut = () => {
    const { zoomMin } = this.state;
    const scale = currentScale(true);

    if (scale === zoomMin) {
      return;
    }

    if ((scale - zoomMin - ZOOM_STEP) < 0.1) {
      zoom(zoomMin);
    }

    else {
      zoomOut(ZOOM_STEP);
    }
  }

  render (props, state) {
    const { showPan, showZoom, showYear, showIconsLegend, minYear, maxYear } = props;
    const { scale, zoomMin, zoomMax } = state;
    const year = props.year || maxYear;
    const yearSliderRatio = (year - minYear) / (maxYear - minYear);
    const adjustedScale = currentScale(true);

    return <div class="MapControls">
      <PanControl visible={ showPan } />

      <div class={`zoom ${showZoom ? 'visible' : ''}`}>
        <Slider min={ zoomMin } max={ zoomMax } step={ ZOOM_STEP } defaultValue={zoomMin} value={ adjustedScale } onInput={ this.zoom } buttons={ true } onIncrease={ this.zoomIn } onDecrease={ this.zoomOut } visible={ showZoom } />
      </div>

      <MapLegend />

      {/*}
      <ul class={`legend-icons ${showIconsLegend ? 'visible' : ''}`}>
        {
          RESOURCES
          .concat(UNREST)
          .map(item =>
            <li>
              <span class="icon">{ item.char }</span>
              <span class="label">{ item.label || `${item.key[0].toUpperCase()}${item.key.slice(1)}` }</span>
            </li>
          )
        }
      </ul>
      */}

      <div class={`year ${showYear ? 'visible' : ''}`}>
        <style id="year-fill">
        {
          `.MapControls .year .Slider:before {
            background-image: linear-gradient(to right, #BCCCD8 calc((${yearSliderRatio} * (100% - 3rem)) + 1.5rem), transparent 0);
          }`
        }
        </style>

        <Slider min={ minYear } max={ maxYear } value={ year } defaultValue={ year } onInput={ this.setYear } onChange={ this.setYear } autofocus={ true } marker={ true } gradation={ true } thumb={ true } visible={ showYear } />
      </div>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./components/MapControls.js